export default __webpack_public_path__ + "b0ae726d86ee4bfcddc9d613fcba741c.png";